/**
 * ExposureBreakdowns - Geographic and Sector exposure charts
 * Extracted from ConsolidatedHoldings.tsx (TASK-371 decomposition)
 *
 * Renders a 2-column grid with Geographic Exposure and
 * Sector Exposure charts, respecting the pie/bar chart toggle.
 */

import React from 'react';
import { MapPin, Activity } from 'lucide-react';
import AllocationPieChart from '../molecules/AllocationPieChart';
import AllocationBarChart from '../molecules/AllocationBarChart';

export interface ExposureBreakdownsProps {
  geographicData: Array<{ name: string; value: number }>;
  sectorData: Array<{ name: string; value: number }>;
  chartType: 'pie' | 'bar';
}

const ExposureBreakdowns: React.FC<ExposureBreakdownsProps> = ({
  geographicData,
  sectorData,
  chartType,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Geographic Exposure */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
            <MapPin className="w-5 h-5 text-blue-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">Geographic Exposure</h3>
        </div>
        {chartType === 'pie' ? (
          <AllocationPieChart
            data={geographicData}
            showLegend={true}
            height={250}
          />
        ) : (
          <AllocationBarChart
            data={geographicData}
            showLegend={false}
            height={250}
          />
        )}
      </div>

      {/* Sector Exposure */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center">
            <Activity className="w-5 h-5 text-purple-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">Sector Exposure</h3>
        </div>
        {chartType === 'pie' ? (
          <AllocationPieChart
            data={sectorData}
            showLegend={true}
            height={250}
          />
        ) : (
          <AllocationBarChart
            data={sectorData}
            showLegend={false}
            height={250}
          />
        )}
      </div>
    </div>
  );
};

export default ExposureBreakdowns;
